module.exports = __webpack_public_path__ + "img/stock1.d33165ac.png";